import React, { Component } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import classNames from 'classnames';
import { Link, withRouter } from 'react-router'
import { Field, FieldArray, reset } from 'redux-form'
import { SkyLightStateless } from 'react-skylight';
import { Translate, Localize } from 'react-redux-i18n';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, DropdownButton, MenuItem, FieldGroup, Input, Breadcrumb } from 'react-bootstrap';
import axios from 'axios';

import ContentWrapper from '../Layout/ContentWrapper';
import Selection from '../Common/selection'
import Spinner from '../Widgets/spinner';
import { InputField, ControlledInputField } from '../Common/inputField';
import IsActive from '../Common/isActive';
import ConfirmActionModal from '../Common/confirmActionModal';
// Helping function to render a multi-fields form. Reference on redux-form array.
import { ROOT_URL, ROOT_API_URL } from '../../actions/root_url';
import { PriceTableModal } from '../Common/priceTableModal';
import lodashMap from 'lodash/map';

const isTQ = ROOT_API_URL === 'https://topquality-scm.truckxi.com/api/'|| ROOT_URL === 'https://topquality-scm.truckxi.com/api/';
const isOCM = ROOT_API_URL === 'https://ocm-scm.truckxi.com/api/'|| ROOT_URL === 'https://ocm-scm.truckxi.com/api/';
const isMAG = ROOT_API_URL === 'https://magna-scm.truckxi.com/api/' || ROOT_URL === 'https://magna-scm.truckxi.com/api/';

let renderIsDefault = props => {
     // Bad implementation, cannot set the value attribute of Input componnet to a boolean.

     const titleClass = classNames({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'control-label', 'col-sm-4')
     return (
       <div>
         <Row><Col sm={ 12 }>{props.meta.touched && props.meta.error && <span className="parsley-error-message">{props.meta.error}</span>}</Col></Row>
         <Row>
           <Col sm={ 5 }>
             <label className="default-address"><Translate value="default_address" /></label>
           </Col>
           <Col sm={ 2 }>
             <label>
                <Input {...props.input} type="radio" value={true} checked={props.input.value == true || props.input.value == "true" }/><Translate value="yes" />
             </label>
           </Col>
           <Col sm={ 2 }>
             <label>
                 <Input {...props.input} type="radio" value={false} checked={props.input.value == false || props.input.value == "false" }/><Translate value="no" />
             </label>
           </Col>
         </Row>
       </div>
     )
 }

class renderShipping extends Component {

    constructor() {
      super();
      this.state = {
        ptModalOpen: false,
        fjCustomerId: "",
      }
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps) {
    }

    copyBillingToShipping(e) {
        e.preventDefault();
        const shipping = cloneDeep(this.props.billing);
        shipping.VendorDetail_id = undefined;
        this.props.changeFieldArrayOfForm('Shipping', 0, shipping, 'vendorDetailForm');
    }

    renderDeleteButton(index, fields) {
      return (
        <Button
          bsStyle="danger"
          className="trash"
          type="reset"
          onClick={() => {
            fields.remove(index);
        } }>
          <em className="fa fa-trash-o"/>
        </Button>
      );
    }

    renderAutoFillButton() {
      return (
        <Button
          bsStyle="default"
          className="auto-fill"
          type="button"
          onClick={this.copyBillingToShipping.bind(this)}>
          <em className="fa fa-edit"/><Translate value="auto_fill" />
        </Button>
      );
    }

    renderAddress (Shipping, index) {
          return (
            <div>
                <Row className="form-horizontal">
                  <div className="form-group">
                    <label className="col-sm-2"><Translate value="name" /></label>
                    <Col sm={ 10 }>
                      <Field name={`${Shipping}.AddressName`} component={ InputField } />
                    </Col>
                  </div>
                </Row>
                <Row className="form-horizontal">
                  <div className="form-group">
                    <label className="col-sm-2"><Translate value="street" /><span className="asteriksReq">*</span></label>
                    <Col sm={ 10 }>
                      <Field name={`${Shipping}.Street`} component={ InputField } />
                    </Col>
                  </div>
                </Row>
                <Row>
                  <Col sm={ 6 }>
                    <div className="form-group">
                      <label><Translate value="city" /><span className="asteriksReq">*</span></label>
                      <Field name={`${Shipping}.City`} component={ InputField } />
                    </div>
                  </Col>
                  <Col sm={ 3 }>
                    <div className="form-group">
                      <label><Translate value="state" /><span className="asteriksReq">*</span></label>
                      <Field name={`${Shipping}.State`} component={ InputField } />
                    </div>
                  </Col>
                  <Col sm={ 3 }>
                    <div className="form-group">
                      <label><Translate value="zip" /><span className="asteriksReq">*</span></label>
                      <Field name={`${Shipping}.Zip`} component={ InputField } />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col sm={ 4 }>
                    <div className="form-group">
                      <label><Translate value="first_name" /></label>
                      <Field name={`${Shipping}.FirstName`} component={ InputField } />
                    </div>
                  </Col>
                  <Col sm={ 4 }>
                    <div className="form-group">
                      <label><Translate value="last_name" /></label>
                      <Field name={`${Shipping}.LastName`} component={ InputField } />
                    </div>
                  </Col>
                  <Col sm={ 4 }>
                    <div className="form-group">
                      <label><Translate value="tel" /></label>
                      <Field name={`${Shipping}.Telephone`} component={ InputField } />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col sm={ 8 }>
                    <div className="form-group">
                      <label><Translate value="email" /></label>
                      <Field name={`${Shipping}.Email`} component={ InputField } />
                    </div>
                  </Col>
                  <Col sm={ 4 }>
                    <div className="form-group">
                      <label><Translate value="fax" /></label>
                      <Field name={`${Shipping}.Fax`} component={ InputField } />
                    </div>
                  </Col>
                </Row>
            </div>
          );
    }

  render() {
    const fields = this.props.fields;
    return (
      <div>
        <Button
          bsStyle="primary"
          className="plus"
          type="button"
          onClick={() => {
            fields.push({})   // pushes empty child field onto the end of the array
        } }>
          <em className="fa fa-plus"/>
        </Button>
        {!fields.length && <div className="marginTopStyle" ><Translate value="no_shipping_information" /></div>}
        {fields.map((Shipping, index) =>
          <div>
            <Row key={index}>
              <Col sm={ 12 }>
                <div className="position-relative">
                  <h4><Translate value="shipping" /> #{index + 1}</h4>
                  {index === 0 && this.renderAutoFillButton()}
                  {this.renderDeleteButton(index, fields)}
                </div>
                {this.renderAddress(Shipping, index)}
                <Field name={`${Shipping}.IsDefault`} component={ renderIsDefault } />
              </Col>
            </Row>
          </div>
        )}
    </div>
    )
  }
}

class VendorDetailForm extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            dirty: false,
            case: "paymentTermMissing",
            vendorImg: [],
        };
        this.openConfirm = this.openConfirm.bind(this);
        this.closeConfirm = this.closeConfirm.bind(this);
    }

    componentWillMount() {
        // reset('productForm');
    }

    componentDidMount() {
        const { currentVendor } = this.props;
        if (currentVendor) {
          this.setState({fjCustomerId: currentVendor.Vendor_id});
          this.props.fetchVendorDetail(currentVendor.Vendor_id)
              .then(() => this.props.fetchPaymentTerms());
        }
        else{
          this.props.fetchPaymentTerms();
          this.props.setDefaultOfForm('IsActive', "false", 'vendorDetailForm');
        }
        // making a leaving hook to confirm leaving
        this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));

        if(isMAG && currentVendor && currentVendor.Vendor_id) {
          this.state.vendorImg = [];
          axios
          .get(
            `${ROOT_URL}v2/upload-vendor-img/` + currentVendor.Vendor_id,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem(
                  "token"
                )}`,
              },
            },
          )
          .then(
            (res) => {
              res.data.map(r=>{
                this.state.vendorImg.push(r);
              })
            },
            (err) => {
              if (err.data) {
                alert(err.data);
              } else {
                alert("Server issue detected, please contact admin.");
              }
            }
          );
  
        }

    }

    componentDidUpdate() {
        // reset('productForm');
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.dirty != this.props.dirty) {
          this.setState({
              dirty: nextProps.dirty
          });
        }
        if(nextProps.isActive && nextProps.isActive != this.props.isActive) {
          console.log("is active", nextProps.isActive)
        }
        if((nextProps.isActive === true || nextProps.isActive === "true") && nextProps.isActive != this.props.isActive) {
          if(!this.props.paymentTerm_id && !nextProps.paymentTerm_id) {
            this.props.setDefaultOfForm('IsActive', "false", 'vendorDetailForm');
            this.openConfirm();
          }
        }
        if(nextProps.paymentTerm_id != this.props.paymentTerm_id) {
          if(!nextProps.paymentTerm_id || nextProps.paymentTerm_id.length === 0 ) {
            this.props.setDefaultOfForm('IsActive', "false", 'vendorDetailForm');
            this.props.setDefaultOfForm('PaymentTerm_id', null, 'vendorDetailForm');
            this.openConfirm();
          }
        }
    }

    routerWillLeave(nextLocation) {
        if (this.state.dirty) return 'Your work is not saved! Are you sure you want to leave?'
    }

    handleFormSubmit(formProps) {
        this.setState({ dirty: false });
        if (!this.props.currentVendor) this.props.createVendor(formProps);
        else {
          if(!this.checkPermission("change_vendor"))
            this.props.editVendor(formProps);
          else
            alert("You have no permission!");
        }
    }

    openConfirm() {
      this.setState({ confirmOpen: true });
    }

    closeConfirm() {
      this.setState({ confirmOpen: false });
    }

    openPTModal() {
      this.setState({ ptModalOpen: true });
    }
    closePTModal() {
      this.setState({ ptModalOpen: false });
    }

    vendorImgDelete(id) {
      const {currentVendor} = this.props;
      let {vendorImg} = this.state;
      axios
                                .delete(
                                  `${ROOT_URL}v2/upload-vendor-img/` + id,
                                  {
                                    headers: {
                                      Authorization: `Bearer ${localStorage.getItem(
                                        "token"
                                      )}`,
                                    },
                                  },
                                )
                                .then(
                                  (res) => {
                                    alert("delete successful");

                                    vendorImg = [];
                                    
                                    axios
                                    .get(
                                      `${ROOT_URL}v2/upload-vendor-img/` + currentVendor.Vendor_id,
                                      {
                                        headers: {
                                          Authorization: `Bearer ${localStorage.getItem(
                                            "token"
                                          )}`,
                                        },
                                      },
                                    )
                                    .then(
                                      (res) => {
                                        res.data.map(r=>{
                                          vendorImg.push(r);
                                        });
                                        this.setState({vendorImg});
                                      },
                                      (err) => {
                                        if (err.data) {
                                          alert(err.data);
                                        } else {
                                          alert("Server issue detected, please contact admin.");
                                        }
                                      }
                                    );

                                  },
                                  (err) => {
                                    if (err.data) {
                                      alert(err.data);
                                    } else {
                                      alert("Server issue detected, please contact admin.");
                                    }
                                  }
                                );
    }

    breadcrumb() {
        if (!this.props.params.id) {
          return <Breadcrumb>
            <Breadcrumb.Item>
              <Translate value="general_management" />
            </Breadcrumb.Item>
            {/* <Breadcrumb.Item>
              <Translate value="vendors" />
            </Breadcrumb.Item> */}
            <Breadcrumb.Item active="true">
              <Translate value="create_vendor" />
            </Breadcrumb.Item>
          </Breadcrumb>
      }
      return <Breadcrumb>
        <Breadcrumb.Item>
          <Translate value="general_management" />
        </Breadcrumb.Item>
        {/* <Breadcrumb.Item>
          <Translate value="vendor" />
        </Breadcrumb.Item> */}
        <Breadcrumb.Item active="true">
          <Translate value="edit_vendor" />
        </Breadcrumb.Item>
      </Breadcrumb>
    }

    renderPaymentTerms() {
        if (this.props.paymentTermsIsLoading) return <Spinner/> // If payment term is loading, show a spinner.
        else {
            let paymentTermOptions = this.getPaymentTermOptions();
            return (
                <div>
                  <Field name="PaymentTerm_id" component={Selection} options={paymentTermOptions}/>
                </div>
            )
        }
    }

    renderVendorImg(info, type) {
      const { vendorImg } = this.state;

      return (
        (true) &&
          <div>
            {
              lodashMap(vendorImg, (r, index) => (
                (true)
                  ? (
                    <Col sm={12} key={index} style={{marginBottom: '5px', fontSize: '15px', display: 'flex', justifyContent: 'space-between'}}>
                      <a href={r.file_url}>{r.filename}</a>
                      <span style={{color: 'red', cursor: 'pointer'}} onClick={() => this.vendorImgDelete(r.id)}>Delete</span>
                    </Col>
                  ) : (
                    <div key={index}>
                    </div>
                  )
              ))
            }
          </div>
      );
  }

    getPaymentTermOptions() {
        var paymentTermOptions = [];
        this.props.paymentTerms.map(paymentTerm => {
            paymentTermOptions.push({ value: paymentTerm.PaymentTerm_id, label: paymentTerm.Name })
        });
        return paymentTermOptions;
    }

    copyBillingToMailing(e) {
      e.preventDefault();
      if(this.props.billing) {
        this.props.setDefaultOfForm('Mailing', this.props.billing, 'vendorDetailForm')
      }
    }

    checkPermission(permission) {
        return false;
    }

    render() {
        const vendorDetails = (<h2><Translate value="vendor_details" /></h2>)
        const billingDetails = (<h2><Translate value="billing_details" /></h2>);
        const mailingDetails = (<h2><Translate value="mailing_details" /></h2>);
        const shippingDetails = (<h2><Translate value="shipping_details" /></h2>);
        const vendorImages = (<h2><Translate value="vendor_images" /></h2>);
        const activeVendor = (<Translate value="active_vendor" />);
        const confirmAction = (<Translate value="confirm_action" />);
        const priceTable = (<Translate value="vendor_price_table" />);
        const { handleSubmit, submitting, pristine } = this.props;
        let createDialogStyle = {
            height: '600px',
            marginTop: '-20%',
            width: '680px',
            marginLeft: '-10%',
            left: '45%',
        };
        const createDialogStylePT = {
          height: '600px',
          marginTop: '-20%',
          width: '600px',
          marginLeft: '-10%',
          left: '45%',
        };
        if (this.props.detailIsLoading && !this.props.detailError) return <ContentWrapper><br/>...reading data</ContentWrapper>
        else if (this.props.detailError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>
        else {
            return (
              //---------------
              // Begin HTML
              //---------------
                <ContentWrapper>
                  <form method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this)) } >
                    {/* Nav Trail */}
                    {this.breadcrumb() }
                    {/* Breadcrumb Buttons */}
                    <ButtonToolbar>

                    {isMAG &&
                      (true) && (
                        <Button
                          bsStyle="success"
                          type="submit"
                          onClick={(e) => {
                            e.preventDefault();
                            this.refs.msoCreateInputRef2.click();
                          }}
                          disabled={this.context.router.routes[1].path === 'vendors/new'}
                          >
                          <em className="fa fa-plus" />
                          <Translate value="upload_id" />
                        </Button>
                      )
                      }
{
                    isMAG &&
                      (true) && (
                        <input
                          type="file"
                          multiple
                          style={{ display: "none" }}
                          onClick={(e)=> {
                            e.target.value = null;
                              }}
                          onChange={(e) => {
                            const { currentVendor } = this.props;
                            const formData = new FormData();
                            let {vendorImg} = this.state;
                            formData.append("FILE", e.target.files[0]);
                            if (e.target.files[0]) {
                              axios
                                .post(
                                  `${ROOT_URL}v2/upload-vendor-img/` + currentVendor.Vendor_id,
                                  formData,
                                  {
                                    headers: {
                                      Authorization: `Bearer ${localStorage.getItem(
                                        "token"
                                      )}`,
                                    },
                                  },
                                )
                                .then(
                                  (res) => {
                                    alert("Upload successful");
                                    vendorImg = [];
                                    axios
                                    .get(
                                      `${ROOT_URL}v2/upload-vendor-img/` + currentVendor.Vendor_id,
                                      {
                                        headers: {
                                          Authorization: `Bearer ${localStorage.getItem(
                                            "token"
                                          )}`,
                                        },
                                      },
                                    )
                                    .then(
                                      (res) => {
                                        res.data.map(r=>{
                                          vendorImg.push(r);
                                        });
                                        this.setState({vendorImg});

                                      },
                                      (err) => {
                                        if (err.data) {
                                          alert(err.data);
                                        } else {
                                          alert("Server issue detected, please contact admin.");
                                        }
                                      }
                                    );



                                    // refresh here
                                  },
                                  (err) => {
                                    if (err.data) {
                                      alert(err.data);
                                    } else {
                                      alert("Server issue detected, please contact admin.");
                                    }
                                  }
                                );
                            }
                          }}
                          ref="msoCreateInputRef2"
                        />
                      )}

                    {
            (isMAG) &&
            <Button
              bsStyle="success"
              type="button"
              onClick={() => this.openPTModal()}
              disabled={this.context.router.routes[1].path === 'vendors/new'}
            >
              <em className="fa fa-pencil" /><Translate value="price_table" />
            </Button>
          }
                      <Button
                        bsStyle="success"
                        type="submit"
                        action="submit">
                          <em className="fa fa-save"/><Translate value="save" />
                      </Button>
                      <Button
                        bsStyle="danger"
                        type="reset"
                        href="/vendors">
                          <em className="fa fa-close"/><Translate value="cancel" />
                      </Button>
                    </ButtonToolbar> {/* End Breadcrumb Buttons */}

                    <Grid id="vendor-form">
                      {/* Row Wrapper */}
                      <Row>
                        {/* Vendor / Billing Column */}
                        <Col sm={ 8 }>
                          <Row>
                            {/* Vendor Details */}
                            <Col sm={ 12 }>
                              <Panel id="vendor-details" header={vendorDetails}>
                                <Row>
                                  <Col sm={ 8 }>
                                    {/* <h3><Translate value="general_information" /></h3> */}
                                  <div className="form-group">
                                    <label><Translate value="name" /><span className="asteriksReq">*</span></label>
                                    <Field name="Name" component={ InputField } />
                                  </div>
                                  <div className="form-group">
                                    <label><Translate value="description" /></label>
                                    <Field name="Description" component={ InputField } />
                                    </div>
                                  </Col>
                                  <Col sm={ 4 }>
                                    {/* <h3><Translate value="payment_information" /></h3> */}
                                     <div className="form-group">
                                       <label><Translate value="payment_term" /></label>
                                       { this.renderPaymentTerms() }
                                     </div>
                                     <div className="form-group">
                                       <label><Translate value="credit_status" /></label>
                                       <Field name="CreditStatus" component={ InputField } />
                                     </div>
                                  </Col>
                                  <Col sm={ 8 }>
                                    <Row>
                                      <Col sm={ 6 }>
                                        <div className="form-group">
                                          <label><Translate value="vendor_no" /><span className="asteriksReq">*</span></label>
                                          <Field name="VendorNum" component={ InputField } />
                                        </div>
                                      </Col>
                                      {
                                        // !isMAG &&
                                        true &&
                                      <Col sm={ 6 }>
                                        <div className="form-group">
                                          <label><Translate value="ref_num" /></label>
                                          <Field name="RefNum" component={ InputField } />
                                        </div>
                                      </Col>
        }
                                              {/* {
                                        isMAG &&
                                      <Col sm={ 6 }>
                                        <div className="form-group">
                                          <label><Translate value="phone" /></label>
                                          <Field name="Phone" component={ InputField } />
                                        </div>
                                      </Col>
        } */}
                                    </Row>
                                  </Col>
                                  <Col sm={ 4 }>
                                    <Field name="IsActive" labelName={activeVendor} component={ IsActive } />
                                  </Col>
                                </Row>
                              </Panel>
                            </Col> {/* End Vendor Details */}

                            {/* Billing Details */}
                            <Col sm={ 6 }>
                              <Panel id="billing-details" header={billingDetails}>
                                {/* <h3><Translate value="billing_address" /></h3> */}
                                <Row className="form-horizontal">
                                  <div className="form-group">
                                    <label className="col-sm-2"><Translate value="name" /></label>
                                    <div className="col-sm-10">
                                      <Field name="Billing.AddressName" component={ InputField } />
                                    </div>
                                  </div>
                                </Row>
                                <Row className="form-horizontal">
                                  <div className="form-group">
                                    <label className="col-sm-2"><Translate value="street" /><span className="asteriksReq">*</span></label>
                                    <div className="col-sm-10">
                                      <Field name="Billing.Street" component={ InputField } />
                                    </div>
                                  </div>
                                </Row>

                                <Row>
                                  <Col sm={ 6 }>
                                    <div className="form-group">
                                      <label><Translate value="city" /><span className="asteriksReq">*</span></label>
                                      <Field name="Billing.City" component={ InputField } />
                                    </div>
                                  </Col>
                                  <Col sm={ 3 }>
                                    <div className="form-group">
                                      <label><Translate value="state" /><span className="asteriksReq">*</span></label>
                                      <Field name="Billing.State" component={ InputField } />
                                    </div>
                                  </Col>
                                  <Col sm={ 3 }>
                                    <div className="form-group">
                                      <label><Translate value="zip" /><span className="asteriksReq">*</span></label>
                                      <Field name="Billing.Zip" component={ InputField } />
                                    </div>
                                  </Col>
                                </Row>

                                {/* <h3><Translate value="billing_contact" /></h3> */}
                                <Row>
                                  <Col sm={(isTQ||isOCM) ? 6 : 4}>
                                    <div className="form-group">
                                      <label><Translate value="first_name" /></label>
                                      <Field name="Billing.FirstName" component={ InputField } />
                                    </div>
                                  </Col>
                                  <Col sm={(isTQ||isOCM) ? 6 : 4}>
                                    <div className="form-group">
                                      <label><Translate value="last_name" /></label>
                                      <Field name="Billing.LastName" component={ InputField } />
                                    </div>
                                  </Col>
                                  {
                                    !(isTQ||isOCM) &&
                                    <Col sm={ 4 }>
                                      <div className="form-group">
                                        <label><Translate value="tel" /></label>
                                        <Field name="Billing.Telephone" component={ InputField } />
                                      </div>
                                    </Col>
                                  }
                                </Row>

                                <Row>
                                  {
                                    !(isTQ||isOCM) &&
                                    <Col sm={ 8 }>
                                      <div className="form-group">
                                        <label><Translate value="email" /></label>
                                        <Field name="Billing.Email" component={ InputField } />
                                      </div>
                                    </Col>
                                  }
                                  {
                                    (isTQ||isOCM) &&
                                    <Col sm={ 8 }>
                                      <div className="form-group">
                                        <label><Translate value="tel" /></label>
                                        <Field name="Billing.Telephone" component={ InputField } />
                                      </div>
                                    </Col>
                                  }
                                  <Col sm={ 4 }>
                                    <div className="form-group">
                                      <label><Translate value="fax" /></label>
                                      <Field name="Billing.Fax" component={ InputField } />
                                    </div>
                                  </Col>
                                </Row>
                                {
                                  (isTQ||isOCM) &&
                                  <Row>
                                    <Col sm={12}>
                                      <div className="form-group">
                                        <label><Translate value="email" /></label>
                                        <span className="asteriksReq"><Translate value="press_enter_for_emails" /></span>
                                          <Field
                                            name="Billing.Email"
                                            component="Textarea"
                                            className="form-control resize-vertical"
                                            style={{ minHeight: '40px' }}
                                            resize="vertical"
                                          />
                                      </div>
                                    </Col> 
                                  </Row>
                                }
                              </Panel>
                            </Col> {/* End Billing Details */}

                            {/* Mailing Details */}
                            <Col sm={ 6 }>
                              <Panel id="mailing-details" header={mailingDetails}>
                                {/* <h3><Translate value="mailing_address" /></h3> */}
                                <Row className="form-horizontal">
                                  <div className="form-group">
                                    <label className="col-sm-2"><Translate value="name" /></label>
                                    <Col sm={ 6 }>
                                      <Field name="Mailing.AddressName" component={ InputField } />
                                    </Col>
                                    <Col sm={ 4 }>
                                      <Button
                                      bsStyle="default"
                                      className="auto-fill"
                                      type="button"
                                      onClick={this.copyBillingToMailing.bind(this)} >
                                        <em className="fa fa-edit"/><Translate value="auto_fill" />
                                      </Button>
                                    </Col>
                                  </div>
                                </Row>
                                <Row className="form-horizontal">
                                    <div className="form-group">
                                      <label className="col-sm-2"><Translate value="street" /><span className="asteriksReq">*</span></label>
                                      <Col sm={ 10 }>
                                        <Field name="Mailing.Street" component={ InputField } />
                                      </Col>
                                    </div>
                                </Row>
                                <Row>
                                  <Col sm={ 6 }>
                                    <div className="form-group">
                                      <label><Translate value="city" /><span className="asteriksReq">*</span></label>
                                      <Field name="Mailing.City" component={ InputField } />
                                    </div>
                                  </Col>
                                  <Col sm={ 3 }>
                                    <div className="form-group">
                                      <label><Translate value="state" /><span className="asteriksReq">*</span></label>
                                      <Field name="Mailing.State" component={ InputField } />
                                    </div>
                                  </Col>
                                  <Col sm={ 3 }>
                                    <div className="form-group">
                                      <label><Translate value="zip" /><span className="asteriksReq">*</span></label>
                                      <Field name="Mailing.Zip" component={ InputField } />
                                    </div>
                                  </Col>
                                </Row>
                                {/* <h3><Translate value="mailing_contact" /></h3> */}
                                  <Row>
                                    <Col sm={ 4 }>
                                      <div className="form-group">
                                        <label><Translate value="first_name" /></label>
                                        <Field name="Mailing.FirstName" component={ InputField } />
                                      </div>
                                    </Col>
                                    <Col sm={ 4 }>
                                      <div className="form-group">
                                        <label><Translate value="last_name" /></label>
                                        <Field name="Mailing.LastName" component={ InputField } />
                                      </div>
                                    </Col>
                                    <Col sm={ 4 }>
                                      <div className="form-group">
                                        <label><Translate value="tel" /></label>
                                        <Field name="Mailing.Telephone" component={ InputField } />
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col sm={ 8 }>
                                      <div className="form-group">
                                        <label><Translate value="email" /></label>
                                        <Field name="Mailing.Email" component={ InputField } />
                                      </div>
                                    </Col>
                                    <Col sm={ 4 }>
                                      <div className="form-group">
                                        <label><Translate value="fax" /></label>
                                        <Field name="Mailing.Fax" component={ InputField } />
                                      </div>
                                    </Col>
                                  </Row>
                              </Panel>
                            </Col> {/* End Mailing Details */}
                          </Row>
                        </Col> {/* End Vendor / Billing Column */}

                        {/* Shipping Information */}
                        <Col sm={ 4 }>
                          <Panel id="shipping-details" header={shippingDetails}>
                            <h3><Translate value="shipping_info" /></h3>
                            <FieldArray
                              name="Shipping"
                              component={renderShipping}
                              shipping={this.props.shipping}
                              billing={this.props.billing}
                              // currentShipping={ this.props.currentVendorDetail ? this.props.currentVendorDetail.Shipping:[]}
                              changeFieldArrayOfForm={this.props.changeFieldArrayOfForm}
                            />
                            {/* <h3><Translate value="contact" /></h3>
                            <FieldArray name="Shipping" component={renderShippings}
                              shipping={this.props.billing}
                              currentShipping={ this.props.currentVendorDetail ? this.props.currentVendorDetail.Shipping:[]}
                              saveCurrentBilling={() => {this.saveCurrentBilling()}}
                              setCurrentShipping={(newShipping) => {this.setCurrentShipping(newShipping)}}
                              /> */}
                          </Panel>
                        </Col> {/* End Shipping Information */}
                        {isMAG &&
                                        <Col sm={ 4 }>
                                        <Panel id="vendor-img" header={vendorImages}>
                                        <Row>
                                          {this.renderVendorImg()}

                                          </Row>
                                          </Panel>
                                        </Col>
                        }
                      </Row> {/* End Row Wrapper */}

                      { this.props.isCreating || this.props.isEditing && <Spinner/> }
                      {/* this.props.createError && <div className="alert alert-danger marginTopStyle" >{JSON.stringify(this.props.createError)}</div> */}
                      {/* this.props.editError && <div className="alert alert-danger marginTopStyle" >{JSON.stringify(this.props.editError)}</div> */}

                      {/* <SkyLightStateless isVisible={this.state.paymentTermOpen} onCloseClicked={() => { this.closePaymentTerm() } } title={addANewPaymentTerm}>
                        <PaymentTermForm closePT={this.closePaymentTerm} />
                      </SkyLightStateless> */}
                    </Grid>
                    <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.confirmOpen} onCloseClicked={() => { this.closeConfirm() }} title={confirmAction}>
                        <ConfirmActionModal case={this.state.case} closeC={this.closeConfirm} />
                    </SkyLightStateless>
                    <SkyLightStateless dialogStyles={createDialogStylePT} isVisible={this.state.ptModalOpen} onCloseClicked={() => { this.closePTModal() }} title={priceTable}>
          <PriceTableModal
              fjCustomerId = {this.state.fjCustomerId}
              fetchPT = {this.props.fetchPT}
              updatePT = {this.props.updatePT}
              // deleteFJAgents = {this.props.deleteFJAgents}
              closePTModal = {this.closePTModal}
              type="Vendor"
            />
          </SkyLightStateless>
                  </form>
                </ContentWrapper>
                //---------------
                // End HTML
                //---------------
            )
        }
    }
}

export default withRouter(VendorDetailForm);



// WEBPACK FOOTER //
// ./master/jsx/components/Vendors/vendorDetailForm.jsx